import React from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { getOptions } from "../../options/options";
import { logger } from "../../lib/utils/logger/logger";

export const COLLECT_INFO_SUBMISSION_TIME = "collect-info-submission-time";
export const COLLECT_INFO_SUBMIT = "collect-info-submit";
export const DOC_UPLOAD_SUBMIT = "doc-upload-submit";
export const DOC_UPLOAD_SUBMISSION_TIME = "doc-upload-submission-time";

const createUniqueId = () => Math.random().toString(36).substr(2, 9);

export const MetricIds = {
  OrgSearchNumReworks: "org-search-num-reworks",
  OrgSearchQueryLength: "org-search-query-length",
  OrgSearchResultRank: "org-search-result-rank",
  OrgSearchTimeUntilSelection: "org-search-time-until-selection",
} as const;

type MetricId = (typeof MetricIds)[keyof typeof MetricIds];

export const useMetrics = ({ segment, programId }: { segment?: string; programId?: string }) => {
  const [randomId] = React.useState(createUniqueId());
  const ldClient = useLDClient();

  React.useEffect(() => {
    // set mark when this component first renders
    try {
      performance.mark(randomId);
    } catch {
      // do nothing if performance.mark errors (this happens in tests because jsdom)
    }
  }, []);

  return {
    // @TODO move GA and NR events into this?
    userDidConvert: (metricIdConverted: string, metricIdSubmitTime: string): void => {
      if (getOptions()._launchDarklyUserTargeting) {
        try {
          const timeOnForm = performance.measure("timeOnForm", randomId);
          ldClient.track(metricIdConverted, {
            segment,
          });

          ldClient.track(
            metricIdSubmitTime,
            {
              segment,
            },
            timeOnForm.duration,
          );
        } catch (e) {
          logger.error("Unable to submit metrics", e);
        }
      }
    },
    recordNumericMetric: (metricId: MetricId, value: number): void => {
      if (getOptions()._launchDarklyUserTargeting) {
        ldClient.track(
          metricId,
          {
            segment,
            programId,
          },
          value,
        );
      }
    },
    /**
     * @deprecated use userDidConvert instead
     */
    getTimeOnForm: (): PerformanceMeasure => {
      try {
        return performance.measure("timeOnForm", randomId);
      } catch (e) {
        // do nothing if performance.mark errors (this happens in tests because jsdom)
      }

      return undefined;
    },
  };
};
